import { restockStore } from '@/@types/restock'
const state = {
    warehouseList: null,
    shippingTypeList: null,
    regionList: null
}
const mutations = {
    setShipping (state: any, restock_shipping:[any]) {
        localStorage.setItem(restockStore.restock_shipping, JSON.stringify(restock_shipping))
        state.shippingTypeList = restock_shipping
    },
    setWarehouse (state: any, restock_warehouse:[any]) {
        localStorage.setItem(restockStore.restock_warehouse, JSON.stringify(restock_warehouse))
        state.warehouseList = restock_warehouse
    },
    setMaps (state: any, restock_maps:[any]) {
        localStorage.setItem(restockStore.restock_maps, JSON.stringify(restock_maps))
        state.warehouseList = restock_maps
    },
    setRegionList (state: any, regionList:[any]) {
        localStorage.setItem(restockStore.region_list, JSON.stringify(regionList))
        state.regionList = regionList
    },
}
const actions = {
    setShipping(context: any, shipping: string) {
        context.commit('setShipping', shipping)
    },
    setWarehouse(context: any, warehouse: string) {
        context.commit('setWarehouse', warehouse)
    },
    setMaps(context: any, maps: string) {
        context.commit('setMaps', maps)
    },
    setRegionList(context: any, regionList: string) {
        context.commit('setRegionList', regionList)
    },
}
export default {
    state,
    mutations,
    actions
}